import { Navigate, Outlet, replace, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

// NOTE: Handle Protected Routes
export const ProtectedRoute = () => {
  const { isAuthenticated, availableRoles } = useSelector((state) => state.auth);

  // If user is not authenticated, redirect them to the sign-in page
  if (!isAuthenticated || (availableRoles.toLowerCase() !== "admin")) {
    return <Navigate to="/" replace />;
  }

  // If the user is authenticated, render the protected route's content
  return <Outlet />;
};

// NOTE: Handle Public Routes
export const PublicRoute = () => {
  
  const { isAuthenticated, availableRoles } = useSelector((state) => state.auth);

  // If user is authenticated, redirect to /admin or the appropriate route
  if (isAuthenticated && (availableRoles.toLowerCase() === "admin")) {
    return <Navigate to="/admin" replace />;
  }

  // Otherwise, render the public routes
  return <Outlet />;
};